<div
  class="ng-loader size-{{ size() }}"
>
  <ng-lottie
    class="ng-lottie"
    [options]="options"
  />
</div>
